  <template>
  <div>
    <v-col cols="12">
      <h3 class="font-weight-bold">
        {{ dataField.title ? dataField.title : "" }}
      </h3>
      <br />
      <v-slider
        v-if = "show"
        v-model="dataFetch"
        min="0"
        :max="this.tickLabel.length - 1"
        step="1"
        tick-size="10"
        :tick-labels="this.tickLabel"
      >
      </v-slider>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: ["dataField"],
  computed: {
    dataPost: {
      get() {
        return this.$store.state.dataPost
      }
    },
    dataFetch:{
      get(){
        let name = this.$store.state.dataPost[this.dataField.name];
        let index = this.tickValue.indexOf(name);
        
        console.log('get',index);
        return index || 0;
      },
      set(val){
        console.log('set',val)
        this.setValue(val)
      }
    }

  },
  watch:{
    dataField : function(newValue){
      let index = this.tickValue.indexOf(newValue.value) || 0;
      console.log(22,index)
      this.show = false;
      this.setValue(index);
      this.show = true;
    }
  },
  data() {
    return {
      tickLabel: [],
      tickValue: [],
      show : true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let data = this.dataField;
      if (data.choices != null) {
        data.choices.map((item) => {
          this.tickValue.push(item.key);
          this.tickLabel.push(item.value);
        });
      }
    },
    setValue(val) {
      this.dataPost[this.dataField.name] = this.tickValue[val];
      this.$store.commit("updateDataPost", this.dataPost);
    },

  },
};
</script>
<style>
@media only screen and (max-width: 600px) {
  .v-slider__ticks-container span:first-child div {
    margin-right: -1em !important;
  }
  .v-slider__ticks-container span:last-child div {
    margin-right: 1em !important;
  }
  .v-slider__ticks-container span:nth-child(odd) div {
    margin-top: -5vh !important;
  }
}
</style>
